import React from 'react';
import PropTypes from 'prop-types';

import { Button } from '@zillow/constellation';
import { useWizard } from '@zillow/zrs-rental-applications';
import { LANDING_STEP, NAME_STEP } from '../../ApplicationManagerModal.util';
import { getIsOnlyAdmin } from '../../../../utils/businessVerification';

function getButtonText(currentStep, employees) {
  switch (currentStep) {
    case LANDING_STEP:
      const isOnlyAdmin = getIsOnlyAdmin(employees);
      return isOnlyAdmin ? 'OK' : 'Yes';
    case NAME_STEP:
      return 'Next';
    default:
      return 'OK';
  }
}
export default function NextButton({ onClose, employees }) {
  const { isOnLastStep, onRequestNext, currentStep } = useWizard();
  const buttonText = getButtonText(currentStep, employees);
  return (
    <Button buttonType="primary" onClick={isOnLastStep ? onClose : onRequestNext}>
      {buttonText}
    </Button>
  );
}

NextButton.propTypes = {
  onClose: PropTypes.func.isRequired,
  employees: PropTypes.array.isRequired,
};
